import { createSlice } from '@reduxjs/toolkit';
import { Service } from 'services/Services';
import { RequestApi } from 'RequestApi';
import { NotificationMessage } from 'components/notification-message/NotificationMessage';
import { setViewingDocument, updateDocument, setFetching } from 'components/dynamic/dynamic-page/dynamic-page-questionaire/DynamicPageQuestionaireSlice';

const initialState = {
  record: null,
  pageInfo: null,
  progressing: false,
  showRemarkActionApproval: false,
  showRemarkApproval: false,
  hostClusterName: '',
};

const dynamicDocumentFormQuestionaireSlice = createSlice({
  name: 'dynamicDocumentFormQuestionaire',
  initialState,
  reducers: {
    setPageInfo(state, action) {
      state.pageInfo = action.payload;
    },

    setRecord(state, action) {
      state.record = action.payload;
    },
    setProgressing(state, action) {
      state.progressing = action.payload;
    },

    setShowRemarkApproval(state, action) {
      state.showRemarkApproval = action.payload;
    },
    setHostClusterName(state, action) {
      state.hostClusterName = action.payload;
    },
  },
});

const { setPageInfo, setHostClusterName } = dynamicDocumentFormQuestionaireSlice.actions;

export const { setRecord, setShowRemarkActionApproval, setShowRemarkApproval } = dynamicDocumentFormQuestionaireSlice.actions;

export const initPageInfo =
  ({ informationPage, document }) =>
  async (dispatch) => {
    try {
      dispatch(setFetching(true));
      dispatch(setPageInfo(informationPage));

      let url = `/employee-training-questionnaire/index-card?`;
      url += `auth_token=${Service.userToken}`;

      const data = JSON.stringify({
        data_unid: document.id,
      });

      RequestApi(url, {
        data,
      })
        .then((res) => {
          if (res.data.status === 'success') {
            dispatch(setRecord(res.data.record));
            dispatch(setHostClusterName(res.data.host_cluster_name));

            if (!document.status) {
              dispatch(setViewingDocument(res.data.record));
            }
          } else {
            NotificationMessage({ message: res.data.msg, status: res.data.status });
          }

          dispatch(setFetching(false));
        })
        .catch((err) => {
          console.log(err);
          dispatch(setFetching(false));
          NotificationMessage({ message: err.toString(), status: 'error' });
        });
    } catch (ex) {
      dispatch(setFetching(false));
      NotificationMessage({ message: ex.toString(), status: 'error' });
    }
  };

export const sendApproval =
  ({ record }) =>
  async (dispatch) => {
    dispatch(setFetching(true));

    const BreakException = {};

    try {
      Object.keys(record.employee_training_questionnaire_lines_groups).forEach((keyValue) => {
        record.employee_training_questionnaire_lines_groups[keyValue].forEach((questionaire) => {
          if (questionaire.answer == null && questionaire.mandatory === 'Yes') {
            NotificationMessage({ message: 'Please filled out all the required forms', status: 'warning' });
            throw BreakException;
          } else {
            let urlRequest = `/employee-training-questionnaire/submit-record?`;
            urlRequest += `auth_token=${Service.userToken}`;

            const data = JSON.stringify({
              record,
            });

            RequestApi(urlRequest, { data })
              .then((res) => {
                dispatch(setFetching(false));
                if (res.data.status === 'success') {
                  dispatch(updateDocument(res.data.record));
                } else {
                  NotificationMessage({ message: res.data.msg, status: res.data.status });
                }
              })
              .catch((err) => {
                dispatch(setFetching(false));
                console.log(err);
                NotificationMessage({ message: err.toString(), status: 'error' });
              });
          }
        });
      });
    } catch (e) {
      if (e !== BreakException) throw e;

      console.log('catch :', e);
    }

    dispatch(setFetching(false));
  };

const dynamicDocumentFormQuestionaireReducer = dynamicDocumentFormQuestionaireSlice.reducer;

export default dynamicDocumentFormQuestionaireReducer;
